// removed by extract-text-webpack-plugin
module.exports = {"yx_yxCircle_sm":"yx_yxCircle_sm___hqbcY","fontSize_1":"fontSize_1___dFZCh","fontSize_2":"fontSize_2___3B8nj","fontSize_3":"fontSize_3___3N0D_","fontSize_4":"fontSize_4___1ktgO","fontSize_5":"fontSize_5___23LT5","fontSize_6":"fontSize_6___1i49B","fontColor_1":"fontColor_1___2cK7Q","fontColor_2":"fontColor_2___CDP1d","fontColor_3":"fontColor_3___j5Igy","fontColor_4":"fontColor_4___1hHqe","fontColor_5":"fontColor_5___1xEFp","fontColor_6":"fontColor_6___2ugMo"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/HeaderGlobal/HeadreGlobal.less
// module id = ./src/widget/HeaderGlobal/HeadreGlobal.less
// module chunks = 43